import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixDialog from "@radix-ui/react-dialog";
import { motion, useReducedMotion } from "motion/react";
import { memo, useCallback } from "react";
const ACTION_SHEET_CONTENT_VARIANTS = {
    animate: {
        opacity: 1,
        y: 0
    },
    exit: {
        opacity: 0,
        y: 300
    },
    initial: {
        opacity: 0,
        y: 300
    }
};
const ACTION_SHEET_CONTENT_REDUCED_VARIANTS = {
    animate: {
        opacity: 1,
        y: 0
    },
    exit: {
        opacity: 0,
        y: 0
    },
    initial: {
        opacity: 0,
        y: 0
    }
};
export const ActionSheetContent = /*#__PURE__*/ memo((param)=>{
    let { children, className, onClose, ...restOfProps } = param;
    const shouldReduceMotion = useReducedMotion();
    const onDragEnd = useCallback((_event, info)=>{
        if (info.offset.y > 40) {
            onClose();
        }
    }, [
        onClose
    ]);
    return /*#__PURE__*/ _jsx(motion.div, {
        animate: "animate",
        className: tailwindMerge("fixed inset-x-0 -bottom-[5vh] top-auto z-portal flex max-h-[85vh] w-full rounded-t-8 bg-surface-1 pb-[5vh]", className),
        drag: "y",
        dragConstraints: {
            top: 0,
            bottom: 0
        },
        exit: "exit",
        initial: "initial",
        onDragEnd: onDragEnd,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.4
        },
        variants: shouldReduceMotion ? ACTION_SHEET_CONTENT_REDUCED_VARIANTS : ACTION_SHEET_CONTENT_VARIANTS,
        ...restOfProps,
        children: /*#__PURE__*/ _jsx(RadixDialog.Content, {
            className: "m-0 flex w-full flex-col gap-2 bg-transparent p-2",
            children: children
        })
    });
});
ActionSheetContent.displayName = "ActionSheetContent";
